import { useEffect } from "react";
import QRCode from "react-qr-code";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import { ReactComponent as ArrowNext } from "icons/arrow-next.svg";

import { syncGdnPhotos } from "actions/pack_gdn";

import StyledModalPhoto from "./styles";

const getTitleByKind = (kind) => {
  switch (kind) {
    case "photo":
      return "Zrób główne zdjęcie produktom";
    case "first_additional_photo":
      return "Zrób dodatkowe zdjęcie produktom";
    case "second_additional_photo":
      return "Zrób dodatkowe zdjęcie produktom";
    case "over_pack_photo":
      return "Zrób nadstanowe zdjęcie produktom";
    default:
      return "Zrób zdjęcie";
  }
};

const ModalPhoto = ({
  gdn_id,
  kind,
  getData,
  handleClose,
  sendMessage,
  openSpeditorModal,
  syncGdnPhotos,
}) => {
  useEffect(() => {
    sendMessage(gdn_id, kind);
  }, []);

  return ReactDOM.createPortal(
    <StyledModalPhoto>
      <div className="photo-wrapper">
        <div className="box-qr">
          <QRCode size={150} value={`gdn_photo|${gdn_id}#${kind}`} />
        </div>
        <div className="box-text">
          <p className="title">{getTitleByKind(kind)}</p>
          <p>
            Zeskanuj QR kod za pomocą telefonu <br /> i zrób zdjęcie produktów
          </p>
          <button
            className="btn-success"
            onClick={async () => {
              const {
                packages,
                photo_url,
                first_additional_photo_url,
                second_additional_photo_url,
                over_pack_photo_url,
              } = await getData();

              syncGdnPhotos({
                photo_url,
                first_additional_photo_url,
                second_additional_photo_url,
                over_pack_photo_url,
              });

              handleClose();
              if (packages.length === 0 && kind === "photo") {
                openSpeditorModal(true);
              }
            }}
          >
            <span>Zrobione</span>
            <ArrowNext />
          </button>
        </div>
      </div>
    </StyledModalPhoto>,
    document.getElementById("root")
  );
};

export default connect(null, (dispatch) => ({
  syncGdnPhotos: (data) => dispatch(syncGdnPhotos(data)),
}))(ModalPhoto);
